export default "__VITE_ASSET__B4OBMHO9__"